import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNavArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2222 1H4.77778C2.69137 1 1 2.69137 1 4.77778V16.1111C1 18.1975 2.69137 19.8889 4.77778 19.8889H14.2222C16.3086 19.8889 18 18.1975 18 16.1111V4.77778C18 2.69137 16.3086 1 14.2222 1Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66602 9.49072H12.3327",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 11.3794H16.9139C16.3881 11.3802 15.8728 11.5271 15.4258 11.804C14.9788 12.0809 14.6177 12.4766 14.3828 12.9471L14.0617 13.5894C13.8268 14.0598 13.4657 14.4556 13.0186 14.7325C12.5716 15.0095 12.0564 15.1564 11.5306 15.1572H7.46948C6.94366 15.1564 6.4284 15.0095 5.98139 14.7325C5.53437 14.4556 5.17325 14.0598 4.93837 13.5894L4.61724 12.9471C4.38238 12.4766 4.02124 12.0809 3.57422 11.804C3.12721 11.5271 2.61195 11.3802 2.08613 11.3794H1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconNavArchive;
